<template>
  <progress-bar
    :display-back="true"
    :image-source="levelComponent.progress"
    @quit="$emit('quit')"
  />
  <scrollable-content>
    <div class="header">{{ $t(feedback.title) }}</div>
    <div class="image-wrapper">
      <img
        class="w-full"
        :src="feedback.path"
      />
    </div>
    <div class="feedback-text">{{ $t(feedback.text) }}</div>
    <answers>
      <div class="w-full flex justify-center mb-6">
        <button class="button button-default"
          @click.prevent="performAction({action: feedback.buttonAction})">
          {{ $t(feedback.buttonTitle) }}
        </button>
      </div>
    </answers>
  </scrollable-content>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        values: 'answers'
      }),
      feedback() {
        if (this.levelComponent?.feedback) {
          return this.levelComponent?.feedback.find(feedback => {
            if (!feedback.depends) {
              return true
            }

            let results = feedback.depends.filter(value => {
              return this.values.indexOf(value) > -1
            })
            return feedback.depends.length === 1
              ? results.length >= 1
              : results.length === feedback.depends.length
          })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .feedback-text {
    @apply
      p-7
      text-center
      text-ctm-black;
  }

  .image-wrapper {
    @apply
      w-full
      max-h-full;
  }

  .header {
    @apply
      p-3.5
      text-xl
      bg-white
      text-center
      text-ctm-primary;
  }
</style>